import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import globals from 'scoreboard/components/globals'
import config from 'scoreboard/components/config'
import calendars from 'scoreboard/components/calendars'
import displayErrorHandler from 'scoreboard/components/display-error-handler'
import listStreamer from 'scoreboard/reports/common/list-streamer'
import BaseReportModel from 'scoreboard/reports/common/base-report-model'
import constants from 'scoreboard/components/constants'

var AnnualMetricData = BaseReportModel.extend({

	periodSelector: false,

	defaults: function() {
		return {
			organizationId: globals.orgId,
			subtype: 'annual-metric-data',
			type: 'report',
			label: i18n.get('report.twelvePeriodReport.title'),
			//these mirror the default values in the server code
			displayOptions: {
				showActual: true,
				showYtd: true,
				showAbbreviatedValues: true
			}
		}
	},

	initialize: function(attrs, opts) {
		BaseReportModel.prototype.initialize.apply(this, arguments)
		this.stale = true
		this.on('change', function() {
			if (!this.hasChanged('dirty') && !_.isEmpty(_.omit(this.changedAttributes(), 'relativePeriodId'))) {
				this.set({ 'dirty': true }, { silent: true })
			}
			this.stale = true
		}.bind(this))

		var periodId = this.get('annualCalendarPeriodId') ||
			calendars.correspondingPeriod(config.ytdCalendarId, globals.periodId).id
		var breakdownId = this.get('breakdownCalendarId') || calendars.calendars[0].id
		this.set({
			'annualCalendarPeriodId': periodId,
			'breakdownCalendarId': breakdownId
		}, {silent: true})
	},

	validate: function(attributes, options) {
		var errors = {}
		if (_.isEmpty(attributes.label)) {
			errors.label = i18n.get('common.error.required', i18n.get('report.title'))
		}
		if (_.isEmpty(attributes.scorecardItem)) {
			errors.scorecardItem = i18n.get('common.error.required', i18n.get('scorecards.scorecardNode'))
		}
		return this.formatErrors(errors, options)
	},

	fetch: function(options) {
		var opts = options || {}
		var params = {
			method: 'GET',
			url: this.urlRoot(this.get('id'), {results: true}),
			contentType: constants.CONTENT_TYPES.APPLICATION_JSON,
			stream: 'results',
			parseForm: function(key, val) {
				if (key == 'form') {
					this.set(val, {silent: true})
				}
			}.bind(this)
		}
		if (this.isNew() || this.get('dirty')) {
			let url = this.urlRoot('results')
			if (_.get(options, 'embeddedToken')) {
				url += `?embeddedToken=${options.embeddedToken}`
			}
			params = _.assign(params, {
				url,
				method: 'POST',
				data: JSON.stringify(this.toJSON(options))
			})
		}

		return listStreamer(this, params).done(function() {
			this.stale = false
		}.bind(this))
	}

})

export default AnnualMetricData

AnnualMetricData.__filename__ = 'reports/annual-metric-data/annual-metric-data-model.js'
